<template>
  <div>
    <loading-panel :visible="loading"></loading-panel>
    <div class="header pb-8 pt-4 pt-lg-5 d-flex profile-header"
        style="min-height: 100vh; background-image: url(img/theme/header-background.png); background-size: cover; background-position: center top;">
      <b-container fluid class="mt-6">
        <b-row >
          <b-col cols="8">
            <h4 class="display-4 text-dark">{{ $t('admin.user.list') }}</h4>
          </b-col>
          <b-col align="right">

          </b-col>
        </b-row>
        <b-row>
          <b-col xl="12" class="card-meetup-admin">
            <b-row class="main-search-admin-div">
              <b-col cols="8" align="left">
              </b-col>
              <b-col cols="4" align="right">
                <input class="search-input search-input-admin" v-model="search" :placeholder="$t('sl.search.title')" @input="searchUsers" v-on:keyup.enter="searchUsers"/> <i @click="searchUsers" class="el-icon-search search-admin"></i>
              </b-col>
            </b-row>
            <b-card no-body>
                <el-table class="table-responsive table"
                          header-row-class-name="thead-light"
                          :data="users">

                    <el-table-column :label="$t('admin.user.firstname')"
                                    width="auto"
                                    min-width="150px"
                                    label-class-name="ml-lg-3">
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                                <b-media-body>
                                    <span class="font-weight-600 name mb-0 pl-lg-3 text-sm">{{ row.usr_firstname }} <span class="user-me">{{ usrConnected.usr_id === row.usr_id?$t('admin.user.me'):'' }}</span></span>
                                </b-media-body>
                            </b-media>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('admin.user.lastname')"
                                    width="auto"
                                    min-width="150px"
                                    label-class-name="ml-lg-3">
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                                <b-media-body>
                                    <span class="font-weight-600 name mb-0 pl-lg-3 text-sm">{{ row.usr_lastname }}</span>
                                </b-media-body>
                            </b-media>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('admin.user.email')"
                                    width="auto"
                                    min-width="150px"
                                    label-class-name="ml-lg-3">
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                                <b-media-body class="ellipsis">
                                    <span class="font-weight-600 name mb-0 pl-lg-3 text-sm">{{ row.usr_email }}</span>
                                </b-media-body>
                            </b-media>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('admin.user.isadmin')"
                                    width="110px"
                                    align="center"
                                    label-class-name=""
                                    v-if="usrConnected.usr_admin">
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                                <b-media-body>
                                  <base-switch color="green" :value="row.usr_admin" @change="changeToAdmin(row)" :disabled="usrConnected.usr_id === row.usr_id"/>
                                </b-media-body>
                            </b-media>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('admin.user.isadminsl')"
                                    width="110px"
                                    align="center"
                                    label-class-name=""
                                    v-if="usrConnected.usr_adminservicelines">
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                                <b-media-body>
                                  <base-switch color="green" :value="row.usr_adminservicelines" @change="changeToAdminSl(row)" :disabled="usrConnected.usr_id === row.usr_id"/>
                                </b-media-body>
                            </b-media>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('admin.user.isdisabled')"
                                    width="120px"
                                    align="center"
                                    label-class-name="">
                        <template v-slot="{row}">
                            <b-media no-body class="align-items-center">
                                <b-media-body>
                                    <base-checkbox class="ml-4" :id="row.usr_id" :checked="row.usr_disabled" @change="toggleActif(row)" :disabled="usrConnected.usr_id === row.usr_id"/>
                                </b-media-body>
                            </b-media>
                        </template>
                    </el-table-column>

                </el-table>
            </b-card>
            <div class="pagination-admin-div">
              <pagination v-model="page" :per-page="perPage" :records="totalItems" @paginate="handlePageChange"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import { Table, TableColumn} from 'element-ui';
  import { mapActions } from "vuex";
  import Pagination from 'vue-pagination-2';

  export default {
    name: 'users-list',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Pagination
    },
    data() {
      this.loadUsers();
      return {
        lang: Vue.i18n.locale(),
        users: [],
        usrConnected: this.$store.getters.User,
        loading: false,
        page: 1,
        totalItems: 0,
        perPage: 10,
        search: ''
      };
    },
    methods: {
        ...mapActions(["GetListUsers", "UpdateUser"]),
        async loadUsers(page = 0) {
          await this.GetListUsers({ page: page, search: this.search })
          const response = this.$store.getters.AllUsers;
          if (response && response.list) {
            this.users = response.list;
            this.totalItems = response.totalItems;
            this.perPage = response.pageSize;
          } else {
            this.users = response;
          }
        },
        async handlePageChange(value) {
          this.page = value;
          await this.loadUsers(value - 1);
        },
        async searchUsers() {
          this.page = 1;
          await this.loadUsers(0);
        },
        async changeToAdmin(usr) {
          this.loading = true;
          await this.UpdateUser({
            usr_id: usr.usr_id,
            usr_admin: !usr.usr_admin
          })
          this.loading = false;
        },
        async changeToAdminSl(usr) {
          this.loading = true;
          await this.UpdateUser({
            usr_id: usr.usr_id,
            usr_adminservicelines: !usr.usr_adminservicelines
          })
          this.loading = false;
        },
        async toggleActif(usr){
          this.loading = true;
          await this.UpdateUser({
            usr_id: usr.usr_id,
            usr_disabled: !usr.usr_disabled
          })
          this.loading = false;
        }
    }
  }
</script>


